
function Header(): HTMLElement  {
    return div(
        a({href:"https://sigment.dev"},"Docs")
    ) 
}
export default Header;